// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"HeaderSection_headerWrapper__c1KEN","header":"HeaderSection_header__NslVR","title":"HeaderSection_title__Jyngy"};